const LOAD_DATA_MASTER_STUDY_PROGRAM           = 'LOAD_DATA_MASTER_STUDY_PROGRAM'
const LOAD_DATA_MASTER_STUDY_PROGRAM_SUCCESS   = 'LOAD_DATA_MASTER_STUDY_PROGRAM_SUCCESS'
const LOAD_DATA_MASTER_STUDY_PROGRAM_FAILED    = 'LOAD_DATA_MASTER_STUDY_PROGRAM_FAILED'
const UNMOUNT_DATA_MASTER_STUDY_PROGRAM        = 'UNMOUNT_DATA_MASTER_STUDY_PROGRAM'
const initialState = {
  loading: true,
  data: null,
  message: null,
}
const studyProgramReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_MASTER_STUDY_PROGRAM:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_MASTER_STUDY_PROGRAM_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_MASTER_STUDY_PROGRAM_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_MASTER_STUDY_PROGRAM:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}
export default studyProgramReducer;